import { Delete } from "@mui/icons-material";
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import vscanService from "../../services/vscanService";
import companyService from "../../services/companyService";

const VscanAdminTable = (props) => {

	let [vscanReports, setVscanReports] = useState(vscanService.vscanReports);
	
	useEffect(() => {
		setVscanReports(vscanService.vscanReports);
	}, [ props.updatedTimestamp ]);
	
	const handleDeleteClick = async (vsr) => {
		await vscanService.deleteVscanReport(companyService.selectedCompany.id, vsr.id);
		setVscanReports(vscanService.vscanReports);
	};
	
	return (
		<TableContainer component={Paper} sx={{ width: "100%" }} updatedTimestamp={props.updatedTimestamp}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell sx={{ textAlign: "left", width: "65%" }}>Reports</TableCell>
						<TableCell sx={{ textAlign: "center", width: "25%" }}>Date</TableCell>
						<TableCell sx={{ textAlign: "center", width: "10%" }}>Delete</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{vscanReports.map((vsr, i) => {
						return (
							<TableRow
								key={`vsr_row_${i}`}
							>
								<TableCell sx={{ textAlign: "left", width: "65%" }}>
									{vsr.filename}
								</TableCell>
								<TableCell sx={{ textAlign: "center", width: "25%" }}>
									{vscanService.getVscanDate(vsr)}
								</TableCell>
								<TableCell sx={{ textAlign: "center", width: "10%" }}>
									<Button onClick={() => { handleDeleteClick(vsr); }}>
										<Delete/>
									</Button>
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</TableContainer>
	);

}

export default VscanAdminTable;